{
  "AboutPage": {
    "get-listed-description": "Möchten Sie Ihr Unternehmen auf dem Trust Marketplace präsentieren?",
    "get-listed-suffix": "Um loszulegen.",
    "get-listed-title": "Jetzt eintragen",
    "how-description": "Händler und Privatpersonen verifizieren ihre Identität, Gewerbeanmeldung und Qualifikationen über die Raytio-Plattform. Jede Verifizierung ist digital signiert und unabhängig überprüfbar, wodurch eine transparente Vertrauenskette gewährleistet wird.",
    "how-title": "Wie die Verifizierung funktioniert",
    "sign-up": "Melden Sie sich bei Raytio an",
    "title": "Über den Trust Marketplace",
    "what-is-description": "Der Raytio Trust Marketplace ist ein öffentliches Verzeichnis verifizierter Händler und Dienstleister. Jeder Eintrag ist kryptografischer Verifizierung unterzogen, sodass die angezeigten Informationen authentisch und vertrauenswürdig sind.",
    "what-is-title": "Was ist der Trust Marketplace?"
  },
  "BookingPage": {
    "book": "Buch",
    "date-range-label": "Nächste",
    "days-label": "Tage",
    "km-away": "{Entfernung} km entfernt",
    "location-label": "Standort",
    "location-placeholder": "Geben Sie Vorort oder Stadt ein...",
    "no-results": "Es wurden keine verfügbaren Termine gefunden. Versuchen Sie, Ihren Suchradius oder den Datumsbereich zu erweitern.",
    "progress": "{vollständig} von {total} Anbietern durchsucht",
    "radius-label": "Innerhalb",
    "search": "Suchen",
    "search-failed": "Suche fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "search-timed-out": "Die Suche wurde aufgrund einer Zeitüberschreitung abgebrochen. Einige Anbieter haben möglicherweise nicht geantwortet.",
    "searching": "Anbietersuche...",
    "service-label": "Service",
    "service-placeholder": "Wählen Sie einen Dienst aus...",
    "sign-in-prompt": "Melden Sie sich mit Ihrem Raytio-Konto an, um nach verfügbaren Terminen zu suchen.",
    "sign-in-to-search": "Anmelden, um zu suchen",
    "sort-closest": "Nächstgelegen",
    "sort-provider": "Vom Anbieter",
    "sort-soonest": "So bald wie möglich",
    "title": "Termin buchen",
    "location-permission-denied": "Die Standortberechtigung wurde verweigert. Bitte geben Sie stattdessen eine Adresse ein.",
    "location-unavailable": "Ihr Standort konnte nicht ermittelt werden. Bitte geben Sie stattdessen eine Adresse ein.",
    "my-location": "Mein Standort",
    "use-my-location": "Meinen Standort verwenden",
    "sign-up-prompt": "Noch kein Konto? Registrieren Sie sich, um nach verfügbaren Terminen zu suchen.",
    "sign-up-to-search": "Registrieren, um zu suchen",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "Alle Länder",
    "filter-by-country": "Nach Land filtern"
  },
  "CtaBar": {
    "book": "Buch",
    "coming-soon": "Demnächst verfügbar"
  },
  "Footer": {
    "about": "Um",
    "powered-by": "Angetrieben von",
    "privacy": "Datenschutz",
    "terms": "Bedingungen"
  },
  "Header": {
    "about": "Um",
    "brand": "Raytio Marketplace",
    "merchants": "Kaufleute",
    "services": "Dienstleistungen",
    "sign-in": "anmelden",
    "sign-out": "Abmelden",
    "sign-up": "Registrieren"
  },
  "HomePage": {
    "subtitle": "Entdecken Sie geprüfte Händler und vertrauenswürdige Dienstleister.",
    "title": "Vertrauensmarktplatz",
    "verified-merchants": "Verifizierte Händler",
    "view-all": "Alle anzeigen"
  },
  "MerchantCard": {
    "unnamed": "Unbekannter Händler",
    "verified": "Verifiziert"
  },
  "MerchantDetail": {
    "active": "Aktiv",
    "approved": "Genehmigt",
    "default-description": "Diesen Händler auf dem Raytio Trust Marketplace ansehen.",
    "forms-heading": "Formulare",
    "forms-sign-in-button": "Melden Sie sich an, um die Formulare anzuzeigen",
    "forms-sign-in-prompt": "Melden Sie sich mit Ihrem Raytio-Konto an, um die Formulare dieses Händlers anzuzeigen.",
    "locations": "Standorte",
    "no-address": "Keine Adresse verfügbar",
    "no-forms-available": "Es sind keine Formulare verfügbar",
    "not-found": "Händler nicht gefunden",
    "primary-use": "Primär",
    "sign-in-prompt": "Melden Sie sich mit Ihrem Raytio-Konto an, um Filialdetails und Standorte dieses Händlers anzuzeigen.",
    "sign-in-to-view": "Melden Sie sich an, um Standorte anzuzeigen",
    "unnamed": "Unbekannter Händler",
    "forms-sign-up-button": "Registrieren, um Formulare anzuzeigen",
    "forms-sign-up-prompt": "Noch kein Konto? Registrieren Sie sich, um auf die Formulare dieses Händlers zuzugreifen."
  },
  "MerchantsPage": {
    "no-merchants": "Keine Händler gefunden.",
    "subtitle": "Durchsuchen Sie verifizierte Händler und vertrauenswürdige Dienstleister.",
    "title": "Händlerverzeichnis"
  },
  "SearchBar": {
    "placeholder": "Händler suchen..."
  },
  "ServiceCategoryFilter": {
    "no-results": "Keine Kategorien gefunden",
    "placeholder": "Zu einer Servicekategorie springen…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "Dienstleistungen",
    "no-merchants": "Für diesen Service wurden keine Anbieter gefunden.",
    "not-found": "Dienst nicht gefunden",
    "search-placeholder": "Suchanbieter...",
    "sign-in-prompt": "Melden Sie sich mit Ihrem Raytio-Konto an, um die Anbieter für diesen Dienst anzuzeigen.",
    "sign-in-to-view": "Melden Sie sich an, um die Anbieter anzuzeigen.",
    "sign-up-prompt": "Noch kein Konto? Registrieren Sie sich, um die Anbieter für diesen Dienst anzuzeigen.",
    "sign-up-to-view": "Registrieren, um Anbieter anzuzeigen"
  },
  "ServiceItemAttributes": {
    "no-data": "Es sind keine Attributdaten verfügbar."
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "Dienstleistungen",
    "hide-details": "Details ausblenden",
    "items-title": "Produkte & Dienstleistungen",
    "no-items": "Es sind keine Produkte oder Dienstleistungen aufgeführt.",
    "not-found": "Nicht gefunden",
    "show-details": "Details anzeigen"
  },
  "ServicesPage": {
    "no-services": "Keine Dienste verfügbar.",
    "services-count": "{count, plural, one {# service} other {# services}}",
    "subtitle": "Dienstleistungen nach Kategorie durchsuchen.",
    "title": "Dienstleistungen"
  },
  "ThemeToggle": {
    "dark-mode": "In den Dunkelmodus wechseln",
    "light-mode": "In den Lichtmodus wechseln"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "Signierte Daten",
    "signature": "Signatur",
    "signing-key": "Signaturschlüssel",
    "verify": "Signatur prüfen",
    "verifying": "Wird geprüft…",
    "verify-valid": "Signatur gültig",
    "verify-invalid": "Signatur stimmt nicht überein",
    "verify-no-key": "Kein Signaturschlüssel hinterlegt — Prüfung nicht möglich",
    "verify-error": "Signaturschlüssel konnte nicht abgerufen werden",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "Wählen Sie Ihre Sitzung",
    "slot-label": "Fach {slotNumber}",
    "choose-duration": "Dauer auswählen",
    "in-use-title": "Dieses Fach ist belegt",
    "in-use-body": "Dieses Fach hat derzeit eine aktive Sitzung. Bitte versuchen Sie es in Kürze erneut.",
    "halted-title": "Kauf wird bearbeitet",
    "halted-body": "Jemand schließt gerade einen Kauf für dieses Fach ab. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
    "no-options": "Für dieses Fach sind keine Optionen verfügbar."
  }
}
